import type { ElementType, ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { getFontColorClassName } from '../../helpers/font-color.linaria';
import type { FontColorType } from '../../helpers/font-styles';
import { splitStylesProp, type StylesProp } from '../../helpers/styles-prop';
import { getTextAlignClassName, type TextAlignment } from '../../helpers/text-align.linaria';
import { HeadingStyles } from './heading.styles';

export interface HeadingProps extends CommonHTMLAttributes {
  as?: ElementType;
  children?: ReactNode;
  className?: string;
  color?: FontColorType;
  level?: 1 | 2 | 3;
  textAlign?: TextAlignment;
  css?: StylesProp;
}

const HTML_TAG_MAP = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
};

export function Heading({
  level = 1,
  color = 'default',
  textAlign = 'left',
  className,
  css,
  as,
  ...props
}: HeadingProps) {
  const Component = !!as ? as : HTML_TAG_MAP[level];
  const headingStyles = HeadingStyles.heading({ level });

  const { css: headingCss, className: headingClassName } = splitStylesProp(css);

  return (
    <Component
      className={cx(
        ...headingStyles,
        getFontColorClassName(color),
        getTextAlignClassName(textAlign),
        className,
        headingClassName
      )}
      css={headingCss}
      {...props}
    />
  );
}
